/**
 * Enum for http request methods.
 * @readonly
 * @enum {string}
 */
const HttpMethods = Object.freeze({
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
    PATCH: 'PATCH',
});

export default HttpMethods;
